export const OCC_SET_SIDEBAR = 'OCC_SET_SIDEBAR';
export const OCC_SET_VIEW = 'OCC_SET_VIEW';
export const OCC_SET_FILTERS = 'OCC_SET_FILTERS';
export const OCC_SET_FILTERS_DATA = 'OCC_SET_FILTERS_DATA';
export const OCC_SET_FILTERS_LOADING = 'OCC_SET_FILTERS_LOADING';
export const OCC_SET_DATA = 'OCC_SET_DATA';
export const OCC_SET_LOADING = 'OCC_SET_LOADING';
export const OCC_SET_MODAL_LIST = 'OCC_SET_MODAL_LIST';
export const OCC_SET_MODAL_LIST_ZONES = 'OCC_SET_MODAL_LIST_ZONES';
